import Service from '@/utils/fetch'

export function add(data) {
    return Service({
        url:'/appInfos',
        data: data,
        method: 'post'
    })
}

export function list(pageNum, pageSize) {
    return Service({
        url:'/appInfos?pageNum='+pageNum+"&pageSize="+pageSize,
        method: 'get'
    })
}

export function getDetails(id) {
    return Service({
        url:'/appInfos/' + id,
        method: 'get'
    })
}

export function update(data) {
    return Service({
        url:"appInfos",
        data: data,
        method: "put"
    })
}

export function remove(id) {
    return Service({
        url:"/appInfos/" + id,
        method: 'delete'
    })
}




// WEBPACK FOOTER //
// ./src/api/App/index.js